import { ToastType, ToastLevelType } from '@components/Toast/Toast';

export enum ToastActionType {
    addToast = '@toast/addToast',
    removeToast = '@toast/removeToast',
}

interface ActionType {
    type: ToastActionType;
}

export interface AddToastActionType extends ActionType {
    toast: ToastType;
}

export function addToast(toast: { id?: string, text: string, type: ToastLevelType, timeout?: number }): AddToastActionType {
    return {
        type: ToastActionType.addToast,
        toast: { id: `toast-${new Date().getTime().toString()}`, timeout: 4000, ...toast },
    };
}

export interface RemoveToastActionType extends ActionType {
    toast: ToastType;
}

export function removeToast(toast: ToastType): RemoveToastActionType {
    return {
        type: ToastActionType.removeToast,
        toast,
    };
}

export type ToastAction = AddToastActionType | RemoveToastActionType;



// WEBPACK FOOTER //
// ./src/actions/toastActions.ts